import { useEffect, useState } from 'react';
import { API_BASE } from '../config';

/**
 * Tabela dni płatnych firmy (N.3) do lokalnego zapasu ceny na ekranach rezerwacji i oferty. Null do
 * nadejścia odpowiedzi, przy jej braku i u firmy bez tabeli: to reguła domyślna. Stan zmienia się
 * wyłącznie u firmy z tabelą, więc pozostałe firmy nie mają nawet dodatkowego renderu.
 */
export function useTabelaDniPlatnych() {
  const [tabela, setTabela] = useState(null);

  useEffect(() => {
    let aktualne = true;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/rental-rules`, { credentials: 'include' });
        if (!res || !res.ok) return;
        const dane = await res.json();
        if (aktualne && dane && dane.paid_days) setTabela(dane.paid_days);
      } catch (_) {
        // Zapas ma działać także bez tej odpowiedzi: reguła domyślna, a kwotę i tak liczy serwer.
      }
    })();
    return () => { aktualne = false; };
  }, []);

  return tabela;
}
